import { PackageOpen } from 'lucide-react';

/**
 * 주문 수집(주문 업데이트) 동안 테이블 전체를 덮는 프로스트 오버레이.
 * 수집이 끝나고 리스트가 리패치될 때까지 표시되며, 그동안 테이블 조작을 막는다.
 * sticky 래퍼: 안내 문구가 페이지 스크롤을 따라와 항상 화면 안에 보인다.
 * 주의 1: overflow-hidden 을 두면 오버레이 자신이 sticky 의 스크롤포트가 되어 고정이 풀린다.
 * 주의 2: sticky 박스에 h-screen 같은 큰 높이를 주면 이동 허용량(컨테이너-자신 높이)이
 *         줄어 금방 고정이 풀리므로, 콘텐츠 크기 그대로 두고 top 오프셋으로 위치를 잡는다.
 */
export const OrderCollectingOverlay = () => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="absolute inset-0 z-[25] rounded-b-[20px] bg-white/95 backdrop-blur-[8px]"
    >
      {/* 보이는 테이블 영역(sticky 헤더 아래 ~ 뷰포트 하단)의 세로 중앙에 오도록:
          top: 고정(pinned) 시 위치 = 헤더 영역(~270px)과 뷰포트 하단의 중간 - 콘텐츠 절반(~100px)
          mt: 스크롤 전 초기 위치도 같은 기준으로 카드 상단(~370px)부터의 거리로 환산 */}
      <div className="sticky top-[calc(50vh-10px)] mt-[max(0px,50vh-240px)] flex flex-col items-center gap-[20px] pb-[40px]">
        {/* 스피너: 은은한 펄스 헤일로 + 회전 링 + 패키지 아이콘 */}
        <div className="relative flex h-[64px] w-[64px] items-center justify-center">
          <div className="absolute -inset-[14px] animate-pulse rounded-full bg-point-500/10 blur-md" />
          <div className="absolute inset-0 rounded-full border-[3px] border-gr-100" />
          <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-transparent border-t-point-500" />
          <PackageOpen className="h-[26px] w-[26px] text-point-500" />
        </div>

        <div className="flex flex-col items-center gap-[6px]">
          <p className="text-gr-900 Title3S18">주문을 수집하고 있어요</p>
          <p className="text-gr-500 Body5M14">수집이 끝나면 주문 목록이 자동으로 최신화돼요</p>
        </div>

        <div className="flex gap-[5px]">
          {[0, 150, 300].map((delay) => (
            <span
              key={delay}
              className="h-[6px] w-[6px] animate-bounce rounded-full bg-point-400"
              style={{ animationDelay: `${delay}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
